<template>
  <section class="tabs-component">
    <div class="inner-container">
      <h1 class="section-title">Por que trabalhar no  Moip é legal?</h1>
      <div class="tab-body">
        <slot></slot>
      </div>
      <ul class="tabs-nav row">
        <li v-for="menuItem in navItemsArray" class="col-2 md-col-2 sm-col-2">
          <button
            class="button"
            role="tab"
            :aria-selected="menuItem.isActive"
            :class="{ active: menuItem.isActive }"
            @click="selectItem(menuItem)">
              <img class="tabs-image" :src="menuItem.image" :alt="menuItem.name" />
          </button>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';

  .tabs-component{
    background: @blue-purple-gradient;
    padding: @xs-spacer 0 (@md-spacer + @xs-spacer);
    border-radius: @border-radius;
    margin: @sm-spacer;

    .section-title{
      color: @white;

      &::after{
        background: @white;
      }
    }
    .name {
      font-weight: @font-weight-bold;
    }
    .tabs-nav{
      .reset();
      list-style: none;
      margin-top: @sm-spacer + @xs-spacer;
      position: relative;
      z-index: 1;
      margin-left: 5%;
      li{
        margin: 0;
      }
    }
    .tab-body{
      padding: @sm-spacer;
      position: relative;
      min-height: 175px;
      margin-top: @md-spacer + @xs-spacer;
      background: @white;
      border-radius: @border-radius;
      box-shadow: 0 32px 32px @dark-blue, 0 16px 16px @dark-blue;
      p {
        line-height: 1;
      }
    }
    .tab-item{
      position: absolute;
      top: @sm-spacer;
      left: @md-spacer;
      width: ~"calc(100% - 80px)";
      color: @blue-2;
      font-size: 20px;
    }
    .tabs-image{
      border-radius: 50%;
      max-width: 100%;
    }
    .button{
      .transition(all, .3s, ease);
      opacity: .5;
      min-width: auto;
      width: 100%;
      position: relative;
      &::before{
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -@md-spacer;
        left: 50%;
        z-index: 1;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid @white;
        transform: translate(-50%, -15px);
        .transition(all, .3s, ease);
        will-change: transform;
      }
      &::after{
        content: "";
        height: 4px;
        width: 0;
        position: absolute;
        border-radius: 10px;
        left: 50%;
        bottom: -@xs-spacer;
        transform: translateX(-50%);
        background: @white;
        .transition(all, .3s, ease);
        will-change: width;
      }
      &.active{
        opacity: 1;
        .transition(all, .3s, ease);
        &::before{
          transform: translate(-50%, 0);
          .transition(all, .3s, ease);
        }
        &::after{
          width: 43px;
          .transition(all, .3s, ease);
        }
      }
    }
  }


</style>

<script>

  export default {
    data() {
      return {
        navItemsArray: [],
        height: ''
      }
    },
    methods: {
      selectItem(itemObject) {
        this.navItemsArray.map((item) => {
          item.isActive = (item === itemObject)
        })
        this.$nextTick(() => {
          this.height = document.querySelector('.tab-item').offsetHeight
        });
      }
    },
    mounted() {
      this.navItemsArray = this.$children
      this.$nextTick(() => {
        this.height = document.querySelector('.tab-item').offsetHeight
      });
    },
    computed: {
      setHeight() {
        return this.height + 30 + 'px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Tabs.vue?5cc26ae0